import React from 'react';
import { Input } from '@roger/ui-components';
import type { AddressFormProps } from '../types';

const AddressForm: React.FC<AddressFormProps> = ({
  address,
  onChange,
  required = false,
}) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <div className='md:col-span-2'>
        <label className='block text-sm font-medium mb-1'>
          Address Line 1 {required && <span className='text-red-500'>*</span>}
        </label>
        <Input
          value={address?.address1 || ''}
          onChange={e => onChange('address1', e.target.value)}
          placeholder='Street address'
          required={required}
        />
      </div>

      <div className='md:col-span-2'>
        <label className='block text-sm font-medium mb-1'>Address Line 2</label>
        <Input
          value={address?.address2 || ''}
          onChange={e => onChange('address2', e.target.value)}
          placeholder='Apartment, suite, etc.'
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>
          City {required && <span className='text-red-500'>*</span>}
        </label>
        <Input
          value={address?.city || ''}
          onChange={e => onChange('city', e.target.value)}
          placeholder='City'
          required={required}
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>
          State {required && <span className='text-red-500'>*</span>}
        </label>
        <Input
          value={address?.state || ''}
          onChange={e => onChange('state', e.target.value)}
          placeholder='State'
          maxLength={2}
          required={required}
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>
          Postal Code {required && <span className='text-red-500'>*</span>}
        </label>
        <Input
          value={address?.postalCode || ''}
          onChange={e => onChange('postalCode', e.target.value)}
          placeholder='ZIP code'
          required={required}
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>Country</label>
        <Input
          value={address?.countryCode || ''}
          onChange={e => onChange('countryCode', e.target.value)}
          placeholder='Country code'
          maxLength={3}
        />
      </div>
    </div>
  );
};

export default AddressForm;
